import { formatPrismicData } from '@monofront/business/utils';
import { FaqProps, IFaq } from './types';

export const mapFaq = ({
  prismicContent,
}: {
  prismicContent: FaqProps['slice'];
}): IFaq => {
  const formattedItems = formatPrismicData(prismicContent.items);

  const items = formattedItems.map(({ accordionTitle, accordionContent }) => ({
    accordionTitle,
    accordionContent,
  }));

  const { title, titleStyle, ctaLink, ctaText } = formatPrismicData(
    prismicContent.primary,
  );

  return {
    title,
    titleStyle,
    ctaLink,
    ctaText,
    items,
  };
};
